const GOOGLE_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL;

// Generic logging function
export async function logInteraction(id, action, extra_data = '') {
    if (!GOOGLE_SCRIPT_URL || GOOGLE_SCRIPT_URL.includes('YOUR_SCRIPT_ID')) {
        console.warn('Google Script URL no configurada');
        return;
    }

    const data = {
        timestamp: new Date().toISOString(),
        id_contribuyente: id,
        action: action, // 'deuda', 'semestre', 'anual', 'ingreso_qr', 'busqueda', etc.
        url: extra_data || window.location.href // If no specific URL provided, use current page URL
    };

    try {
        // mode: 'no-cors' is important for Google Forms/Script simple posts to avoid CORS errors
        await fetch(GOOGLE_SCRIPT_URL, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
    } catch (err) {
        console.error('Error enviando log:', err);
    }
}

export function pickVisibleFields(props = {}) {
    const out = {};
    const wanted = ['Nomenclatura', 'Nombre', 'domicilio', 'id_contribuyente'];
    for (const w of wanted) {
        const foundKey = Object.keys(props).find(k => k.toLowerCase() === w.toLowerCase());
        out[w] = foundKey ? props[foundKey] : '';
    }
    return out;
}

export function pickCommerceFields(props = {}) {
    const out = {};

    // Normalizes string: lowercase, remove accents, remove spaces/underscores
    const normalize = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/_/g, '').replace(/ /g, '');

    // Helper to find key by approximate name
    const find = (candidates) => {
        const keys = Object.keys(props);
        for (const c of candidates) {
            // 1. Exact match (fast path)
            let match = keys.find(k => k === c);
            // 2. Case insensitive
            if (!match) match = keys.find(k => k.toLowerCase() === c.toLowerCase());
            // 3. Normalized match (ignore accents, spaces, _)
            if (!match) match = keys.find(k => normalize(k) === normalize(c));

            if (match) return props[match];
        }
        return null; // Return null so we can check if found
    };

    out.id_contribuyente = find(['id_contribuyente_comercio', 'id_contribuyente', 'id']) || '-';
    // Prioritize 'Razón Social' variations. Removed generic 'nombre' to avoid picking up Parcel Owner name if present.
    out.razon_social = find(['Razón Social', 'Razon Social', 'RazonSocial', 'razon_social', 'nombre_comercio', 'nombre_fantasia']) || find(['nombre']) || '-';
    out.domicilio = find(['domicilio_comercio', 'domicilio', 'direccion']) || '-';
    out.rubro = find(['rubro', 'actividad']) || '-';

    return out;
}

export async function copyToClipboard(text) {
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(text);
        } else {
            const ta = document.createElement('textarea');
            ta.value = text;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
        }
    } catch (err) {
        console.error('Failed to copy:', err);
    }
}
